export const BooleanStringParam = {
  encode: (value: boolean | null | undefined) => (value === true ? 'true' : value === false ? 'false' : undefined),
  decode: (value: string | (string | null)[] | null | undefined) =>
    value === 'true' ? true : value === 'false' ? false : undefined
};
